import React, { useState } from 'react';

const QuickVehicleForm = ({ customerId, onSubmit, onCancel, loading }) => {
  const [formData, setFormData] = useState({
    brand: '',
    model: '',
    year: '',
    license_plate: '',
    fuel_type: '',
    mileage: ''
  });

  const [errors, setErrors] = useState({});

  const fuelTypes = [
    'Essence',
    'Diesel', 
    'Electrique',
    'Hybride',
    'GPL',
    'GNV'
  ];

  const currentYear = new Date().getFullYear();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Effacer l'erreur pour ce champ
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.brand.trim()) {
      newErrors.brand = 'La marque est requise';
    }

    if (!formData.model.trim()) {
      newErrors.model = 'Le modèle est requis';
    }

    if (formData.year && (isNaN(formData.year) || formData.year < 1900 || formData.year > currentYear + 1)) {
      newErrors.year = `L'année doit être entre 1900 et ${currentYear + 1}`;
    }

    if (formData.mileage && (isNaN(formData.mileage) || formData.mileage < 0)) {
      newErrors.mileage = 'Le kilométrage doit être un nombre positif';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    try {
      const vehicleData = {
        ...formData,
        customer_id: customerId,
        year: formData.year ? parseInt(formData.year) : null,
        mileage: formData.mileage ? parseInt(formData.mileage) : null
      };

      await onSubmit(vehicleData);
    } catch (error) {
      console.error('Erreur lors de la création du véhicule:', error);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content quick-vehicle-modal">
        <div className="modal-header">
          <h3>Nouveau Véhicule Rapide</h3>
          <button className="close-btn" onClick={onCancel} type="button">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
            </svg>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="quick-vehicle-form">
          <div className="form-grid">
            <div className="form-group">
              <label htmlFor="brand">Marque *</label>
              <input
                type="text"
                id="brand"
                name="brand"
                value={formData.brand}
                onChange={handleChange}
                className={errors.brand ? 'error' : ''}
                placeholder="Ex: Peugeot, Renault..."
                autoFocus
              />
              {errors.brand && <span className="error-message">{errors.brand}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="model">Modèle *</label>
              <input
                type="text"
                id="model"
                name="model"
                value={formData.model}
                onChange={handleChange}
                className={errors.model ? 'error' : ''}
                placeholder="Ex: 308, Clio..."
              />
              {errors.model && <span className="error-message">{errors.model}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="year">Année</label>
              <input
                type="number"
                id="year"
                name="year"
                value={formData.year}
                onChange={handleChange}
                className={errors.year ? 'error' : ''}
                placeholder="2020"
                min="1900"
                max={currentYear + 1}
              />
              {errors.year && <span className="error-message">{errors.year}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="fuel_type">Carburant</label>
              <select
                id="fuel_type"
                name="fuel_type"
                value={formData.fuel_type}
                onChange={handleChange}
              >
                <option value="">Sélectionner...</option>
                {fuelTypes.map(fuel => (
                  <option key={fuel} value={fuel}>
                    {fuel}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="license_plate">Plaque d'immatriculation</label>
              <input
                type="text"
                id="license_plate"
                name="license_plate"
                value={formData.license_plate}
                onChange={handleChange}
                placeholder="AB-123-CD"
                style={{ textTransform: 'uppercase' }}
              />
            </div>

            <div className="form-group">
              <label htmlFor="mileage">Kilométrage</label>
              <input
                type="number"
                id="mileage"
                name="mileage"
                value={formData.mileage}
                onChange={handleChange}
                className={errors.mileage ? 'error' : ''}
                placeholder="50000"
                min="0"
              />
              {errors.mileage && <span className="error-message">{errors.mileage}</span>}
            </div>
          </div>

          <div className="form-actions">
            <button type="button" onClick={onCancel} className="btn-secondary">
              Annuler
            </button>
            <button type="submit" disabled={loading} className="btn-primary">
              {loading ? 'Création...' : 'Créer Véhicule'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default QuickVehicleForm;
